import { useState } from "react";
import { toast } from "sonner";
import { MessageCircle, Copy, X, ChevronRight } from "lucide-react";
import { whatsappLink } from "@/lib/whatsapp";

export function ClubWhatsApp({ people }) {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const [idx, setIdx] = useState(0);
  const list = people.map((m) => ({ ...m, wa: whatsappLink(m.phone) })).filter((m) => m.wa);

  const copy = async () => {
    const text = list.map((m) => `+${m.wa.split("/").pop()}`).join("\n");
    try { await navigator.clipboard.writeText(text); toast.success(`${list.length} números copiados`); }
    catch { toast.error("Não foi possível copiar"); }
  };

  const next = () => {
    const m = list[idx];
    const first = (m.name || "").split(" ")[0];
    const text = msg.replace(/\{nome\}/gi, first);
    window.open(`${m.wa}${text ? `?text=${encodeURIComponent(text)}` : ""}`, "_blank", "noreferrer");
    setIdx(idx + 1);
  };

  return (
    <>
      <button onClick={() => { setOpen(true); setIdx(0); }} disabled={!list.length}
        className="px-3 py-2 border border-[#25D366]/60 text-[10px] uppercase tracking-widest font-bold text-[#25D366] hover:bg-[#25D366]/10 inline-flex items-center gap-1.5 transition-colors disabled:opacity-40"
        data-testid="club-whatsapp-open">
        <MessageCircle className="w-3.5 h-3.5" /> WhatsApp ({list.length})
      </button>
      {open && (
        <div className="fixed inset-0 z-[80] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4" data-testid="club-whatsapp-dialog">
          <div className="kw-card p-6 w-full max-w-lg space-y-4">
            <div className="flex items-center gap-2">
              <MessageCircle className="w-5 h-5 text-[#25D366]" />
              <span className="font-display font-black uppercase flex-1">WhatsApp a {list.length} membros</span>
              <button onClick={() => setOpen(false)} data-testid="club-whatsapp-close"><X className="w-4 h-4 text-[#737373] hover:text-white" /></button>
            </div>
            <div className="space-y-2">
              <div className="kw-overline text-[10px]">1 · Criar grupo ou lista de transmissão</div>
              <button onClick={copy} className="kw-btn-secondary text-xs inline-flex items-center gap-2" data-testid="club-whatsapp-copy">
                <Copy className="w-3.5 h-3.5" /> Copiar os {list.length} números
              </button>
            </div>
            <div className="space-y-2 border-t border-[#222] pt-4">
              <div className="kw-overline text-[10px]">2 · Mesma mensagem, uma conversa de cada vez</div>
              <textarea className="kw-input w-full min-h-[110px] text-sm" value={msg} onChange={(e) => setMsg(e.target.value)}
                placeholder="Olá {nome}, …  ({nome} é trocado pelo primeiro nome)" data-testid="club-whatsapp-message" />
              {idx < list.length ? (
                <button onClick={next} className="kw-btn-primary !py-2 text-xs inline-flex items-center gap-2" data-testid="club-whatsapp-next">
                  Abrir conversa {idx + 1} de {list.length}: {list[idx].name} <ChevronRight className="w-3.5 h-3.5" />
                </button>
              ) : (
                <div className="text-xs text-[#25D366]" data-testid="club-whatsapp-done">Concluído — todas as conversas foram abertas.</div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
